import React from "react";
import "../css/Home7.css";

const Home7 = () => {
  return (
    <div className="home7">

      {/* ================= HERO ================= */}
      <section className="h7-hero">
        <div className="h7-hero-left">
          <h1>
            TRAIN WITH <span>PULSE</span><br />
            BUILD REAL POWER
          </h1>
          <p>
            High-intensity training, elite coaching, and disciplined routines
            designed to push your limits — every single day.
          </p>
        </div>

        <div className="h7-hero-right">
          <img
            src="https://images.pexels.com/photos/3763878/pexels-photo-3763878.jpeg"
            alt="training"
          />
        </div>
      </section>


      {/* ================= STATS ================= */}
      <section className="h7-stats">
        <div className="stat-box">
          <h2>10K+</h2>
          <p>Members Trained</p>
        </div>
        <div className="stat-box">
          <h2>120+</h2>
          <p>Weekly Sessions</p>
        </div>
        <div className="stat-box">
          <h2>18</h2>
          <p>Elite Coaches</p>
        </div>
        <div className="stat-box">
          <h2>24/7</h2>
          <p>Access & Support</p>
        </div>
      </section>


      {/* ================= PHILOSOPHY ================= */}
      <section className="h7-philosophy">
        <h2>Our Training Philosophy</h2>

        <div className="philo-grid">
          <div className="philo-card">
            <h3>Discipline</h3>
            <p>Consistency beats motivation. We train with structure.</p>
          </div>

          <div className="philo-card">
            <h3>Progression</h3>
            <p>Every session builds on the last. No wasted reps.</p>
          </div>

          <div className="philo-card">
            <h3>Recovery</h3>
            <p>Smart rest ensures longevity and peak performance.</p>
          </div>
        </div>
      </section>


      {/* ================= SPLIT PERFORMANCE ================= */}
      <section className="h7-split">
        <div className="split-img">
          <img
            src="https://images.pexels.com/photos/1552106/pexels-photo-1552106.jpeg"
            alt="strength"
          />
        </div>

        <div className="split-text">
          <h2>Performance Driven Training</h2>
          <p>
            Strength, endurance, speed, and mobility — every program is built
            with intention and athletic structure.
          </p>
        </div>
      </section>


      {/* ================= PROGRAM MATRIX ================= */}
      <section className="h7-programs">
        <h2>Training Systems</h2>

        <div className="program-grid">
          <div className="program">
            <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" />
            <h4>Strength Systems</h4>
          </div>

          <div className="program">
            <img src="https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg" />
            <h4>Conditioning</h4>
          </div>

          <div className="program">
            <img src="https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg" />
            <h4>Mobility & Recovery</h4>
          </div>

          <div className="program">
            <img src="https://images.pexels.com/photos/3763877/pexels-photo-3763877.jpeg" />
            <h4>Athletic Power</h4>
          </div>

          <div className="program">
            <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" />
            <h4>Endurance</h4>
          </div>

          <div className="program">
            <img src="https://images.pexels.com/photos/3822187/pexels-photo-3822187.jpeg" />
            <h4>Functional Training</h4>
          </div>
        </div>
      </section>


      {/* ================= TRAINER QUOTE ================= */}
      <section className="h7-quote">
        <blockquote>
          “Strong bodies are built through structure, patience, and relentless
          effort.”
        </blockquote>
      </section>


      {/* ================= IMAGE WALL ================= */}
      <section className="h7-wall">
        <img src="https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg" />
        <img src="https://images.pexels.com/photos/3763878/pexels-photo-3763878.jpeg" />
        <img src="https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg" />
        <img src="https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg" />
      </section>


      {/* ================= FINAL STATEMENT ================= */}
      <section className="h7-statement">
        <h2>
          DISCIPLINE BUILDS <span>CHAMPIONS</span>
        </h2>
        <p>Train with intent. Perform with confidence.</p>
      </section>

    </div>
  );
};

export default Home7;
